import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  button: {
    margin: theme.spacing(1)
  }
}));

export default props => {
  const classes = useStyles();
  const [query, setQuery] = useState('');

  const handleSearch = () => props.onSearch(query);

  const handleKeyDown = e => e.keyCode === 13 && handleSearch();

  return (
    <div className={classes.container} noValidate>
      <TextField
        id="standard-name"
        label="Song name"
        className={classes.textField}
        value={query}
        onChange={e => setQuery(e.target.value)}
        margin="normal"
        placeholder="Type the name of a track (e.g. Devon Loch Me Here)"
        onKeyDown={handleKeyDown}
      />
      <Button
        onClick={handleSearch}
        variant="contained"
        color="primary"
        className={classes.button}
      >
        {'Search track & get features'}
      </Button>
    </div>
  );
};
